export default {
  title: 'Usuarios',
  user: 'Usuario',
  users: 'Usuarios',

  titles: {
    create: 'Crear un nuevo usuario',
    token: 'Clave API',
    presets: 'Preajustes',

    add: {
      funds: 'Agregar fondos'
    }
  },

  contents: {
    routingGroups: {
      confirm: {
        remove: 'Confirme la eliminación del grupo de enrutamiento solo de la configuración del usuario actual.'
      }
    }
  },

  labels: {
    owner: 'Propietario',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    reseller: 'Revendedor',
    manager: 'Gerente',
    referralCode: 'Código de referencia del usuario',
    target: 'sin nombres de remitentes | un nombre de remitente | {count} nombres de remitentes',
    sendernames: 'Nombres de remitentes',
    patterns: 'Patrones',

    isActive: {
      true: 'El acceso al panel está permitido',
      false: 'El acceso al panel está restringido'
    },

    strict: {
      true: 'La coincidencia estricta está activada',
      false: 'La coincidencia estricta está desactivada',
      undefined: 'La coincidencia estricta no está definida'
    },

    data: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',

      partnership: {
        hasContract: {
          true: 'El contrato está firmado',
          false: 'El contrato no está firmado',
          undefined: 'El estado del contrato no está definido'
        }
      },

      meta: {
        source: 'Fuente',
        usedReferralCode: 'Código de referencia utilizado'
      }
    },

    no: {
      manager: 'Sin gerente'
    }
  },

  tabs: {
    general: 'General',
    settings: 'Configuraciones',
    settingsUser: 'Configuraciones',
    permissions: 'Permisos',
    tariffs: 'Tarifas',
    routingGroups: 'Rutas',
    processMessages: 'Procesamiento de mensajes',
    requisites: 'Requisitos',
    whatsapp: 'WhatsApp',
    recurrentPayments: 'Pagos automáticos',
    referral: 'Recargas de referencia',
    tokens: 'Tokens',
    eventsHistory: 'Historial de eventos',
    eventsHistoryTab: 'Historial de cambios',
    userComments: 'Comentarios',
    userChannels: 'Canales OTP',
    domainsUsers: 'Dominios',
    advanced: 'Avanzado',
    granular: 'Granular',
    secret: 'Secreto'
  },

  hints: {
    password: 'Cree una contraseña segura'
  },

  infos: {
    associationsByType: `
<strong>El interruptor de coincidencia estricta</strong> es una
configuración independiente del usuario.
No está relacionado con los datos del usuario.<br>
Para evitar una activación o desactivación accidental, se añadió un botón
de confirmación <strong>Guardar</strong>.<br><br>

<i>Después de cada cambio del interruptor</i> de coincidencia estricta,
hay que pulsar <strong>Guardar</strong>, porque ahora este cambio no se
guarda automáticamente.<br><br>

Si la coincidencia estricta está activada para el campo
<strong>Nombres de remitentes</strong>, el usuario podrá usar solo
los nombres de remitente seleccionados al crear un mensaje.<br>
Si la coincidencia estricta está activada para el campo
<strong>Patrones</strong>, durante la moderación de mensajes del usuario
se aplicarán solo los patrones seleccionados.<br><br>

Los campos <strong>Nombres de remitentes</strong> y
<strong>Patrones</strong> forman parte de los datos del usuario.<br>
Los cambios en estos campos se guardan solo al pulsar el botón
<strong>Actualizar</strong>.
`
  },

  warnings: {
    apiKey: 'Desafortunadamente, la clave API excede la longitud permitida. Intente cambiar el nombre de usuario y recargar la página o comuníquese con su gerente para obtener ayuda.',
    noTypes: 'No hay tipos de envíos disponibles.',

    permissions: {
      strict: {
        sendernames: 'No tiene permisos suficientes para ver la coincidencia estricta de nombres de remitente.',
        patterns: 'No tiene permisos suficientes para ver la coincidencia estricta de patrones.'
      }
    }
  },

  errors: {
    permissions: {
      get: {
        messageRuleGroups: 'No tiene permisos suficientes para ver los grupos de reglas de procesamiento de mensajes.'
      }
    }
  },

  tooltips: {
    name: 'Nombre: {name}',
    overdraft: 'Sobregiro: {overdraft}',
    reseller: 'Revendedor: {reseller}',
    manager: 'Gerente: {manager}',
    isActive: 'Este indicador controla el acceso del usuario a la plataforma. Esto forma parte de los datos del usuario, por lo que los cambios se guardan solo después de pulsar el botón "Actualizar".',
    isVerifiedByPhone: 'El teléfono está verificado, los cambios están deshabilitados. Si desea cambiar el número de teléfono, póngase en contacto con el soporte.',
    user: `Nombre: {firstName}
Apellido: {lastName}
Teléfono: {phone}
Correo electrónico: {email}
`,

    data: {
      meta: {
        isVerifiedByPhone: 'Activa o desactiva la verificación del teléfono. El cambio se guarda solo después de pulsar el botón "Actualizar".'
      }
    },

    add: {
      funds: 'Agregar fondos'
    },

    generate: {
      document: 'Descargar documento',
      password: 'Generar contraseña'
    },

    copy: {
      apiKey: 'Copiar clave API',

      referral: {
        code: 'Copiar código de referencia',
        link: 'Copiar enlace de referencia'
      }
    },

    strict: {
      sendernames: 'El usuario podrá usar solo los nombres de remitentes seleccionados en el campo inferior al crear un mensaje.',
      patterns: 'Durante la moderación de los mensajes del usuario se aplicarán solo los patrones seleccionados en el campo inferior.'
    }
  },

  buttons: {
    account: 'Perfil',
    password: 'Cambiar contraseña'
  },

  snackbars: {
    created: 'Usuario creado con éxito.',
    updated: 'Usuario actualizado con éxito.',
    removed: 'Usuario eliminado con éxito.',
    linkCopied: 'Enlace copiado con éxito.',
    refCopied: 'Código de referencia copiado con éxito.',

    copy: {
      apiKey: 'Clave API copiada con éxito.'
    }
  }
}
